import { render, staticRenderFns } from "./WarehouseManagementTable.vue?vue&type=template&id=36828b2c"
import script from "./WarehouseManagementTable.vue?vue&type=script&lang=js"
export * from "./WarehouseManagementTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports